/** LTL (standard) total — first service card. */
const RATE_QUOTE_REVIEW_LTL_TOTAL_AMOUNT = 742.62;

/** UC / Volume total — second and third service cards. */
const RATE_QUOTE_REVIEW_UC_TOTAL_AMOUNT = 873.2;

/** UC / Volume Guaranteed Service charge in expanded quote details. */
const RATE_QUOTE_REVIEW_GUARANTEED_SERVICE_CHARGE = 132.33;

/** Percent paired with Guaranteed Service in expanded quote details. */
const RATE_QUOTE_REVIEW_GUARANTEED_SERVICE_PERCENT = 30.4;

export const RATE_QUOTE_REVIEW_PENDING_QUOTE_NUMBER = "QT-Pending";

/** Shown beside UC / Volume total (+$130.58 = UC total − LTL total). */
const getRateQuoteReviewPremiumCollapsedAddon = (): string => {
  const delta =
    RATE_QUOTE_REVIEW_UC_TOTAL_AMOUNT - RATE_QUOTE_REVIEW_LTL_TOTAL_AMOUNT;
  return `+$${delta.toFixed(2)}`;
};

/** Expanded UC / Volume row: Guaranteed Service — $132.33 (30.40%). */
const getRateQuoteReviewGuaranteedServiceDisplay = (): string =>
  `$${RATE_QUOTE_REVIEW_GUARANTEED_SERVICE_CHARGE.toFixed(2)} (${RATE_QUOTE_REVIEW_GUARANTEED_SERVICE_PERCENT.toFixed(2)}%)`;

/** Shared charge breakdown + per-card totals for rate quote review. */
export const mockRateQuoteReviewPricing = {
  additionalServices: [
    {
      id: 1,
      title: "Inside Pickup Required",
      charge: "45.23",
    },
    {
      id: 2,
      title: "Delivery Appointment Not Required",
      charge: "116.14",
    },
    {
      id: 3,
      title: "Grocery Warehouse Delivery",
      charge: "198.15",
    },
  ],
  freightCharges: "450.00",
  grossCharge: "450.00",
  discountAmount: "315.00",
  discountPercent: "70",
  fuelSurcharge: "134.00",
  standard: {
    quoteId: "rate-quote-ltl",
    totalAmount: RATE_QUOTE_REVIEW_LTL_TOTAL_AMOUNT.toFixed(2),
  },
  guaranteed: {
    quoteId: "rate-quote-uc",
    guaranteedService: RATE_QUOTE_REVIEW_GUARANTEED_SERVICE_CHARGE.toFixed(2),
    totalAmount: RATE_QUOTE_REVIEW_UC_TOTAL_AMOUNT.toFixed(2),
  },
  volume: {
    quoteId: "rate-quote-volume",
    guaranteedService: RATE_QUOTE_REVIEW_GUARANTEED_SERVICE_CHARGE.toFixed(2),
    totalAmount: RATE_QUOTE_REVIEW_UC_TOTAL_AMOUNT.toFixed(2),
  },
};

const premiumCollapsedAddon = getRateQuoteReviewPremiumCollapsedAddon();
const guaranteedServiceDisplay = getRateQuoteReviewGuaranteedServiceDisplay();

/** Card order and header/body options for Rate Quote Review service selection. */
export const rateQuoteReviewServiceCards = [
  {
    key: "ltl",
    serviceDisplayName: "LTL",
    quoteId: mockRateQuoteReviewPricing.standard.quoteId,
    totalAmount: mockRateQuoteReviewPricing.standard.totalAmount,
    showRecommendedBadge: false,
    showSpeedIcon: false,
    showTruckIcon: true,
    includeGuaranteedServiceLine: false,
  },
  {
    key: "uc",
    serviceDisplayName: "UC",
    quoteId: mockRateQuoteReviewPricing.guaranteed.quoteId,
    totalAmount: mockRateQuoteReviewPricing.guaranteed.totalAmount,
    showRecommendedBadge: false,
    showSpeedIcon: true,
    showTruckIcon: false,
    includeGuaranteedServiceLine: true,
    collapsedPriceAddon: premiumCollapsedAddon,
    guaranteedServiceChargeDisplay: guaranteedServiceDisplay,
  },
  {
    key: "volume",
    serviceDisplayName: "Volume",
    quoteId: mockRateQuoteReviewPricing.volume.quoteId,
    totalAmount: mockRateQuoteReviewPricing.volume.totalAmount,
    showRecommendedBadge: false,
    showSpeedIcon: false,
    showTruckIcon: false,
    includeGuaranteedServiceLine: true,
    collapsedPriceAddon: premiumCollapsedAddon,
    guaranteedServiceChargeDisplay: guaranteedServiceDisplay,
  },
];
